"use client";

import { useEffect } from "react";

/**
 * Service Worker 조기 등록 컴포넌트
 *
 * PWA 초기 로딩 최적화:
 * - 페이지 로드 시 즉시 Service Worker 등록
 * - usePushNotifications 훅과 별개로 SW만 먼저 등록
 * - 첫 방문부터 asset 캐싱 시작하여 재방문 시 빠른 로딩
 */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    // 개발 모드에서는 SW 등록 스킵 (Turbopack HMR과 stale chunk 캐싱 충돌 방지)
    // 로컬에서 푸시 등록을 테스트하려면 .env.local 에 NEXT_PUBLIC_ENABLE_SW_DEV=true 추가
    if (
      process.env.NODE_ENV === "development" &&
      process.env.NEXT_PUBLIC_ENABLE_SW_DEV !== "true"
    ) {
      return;
    }

    // 이미 등록된 SW가 있으면 스킵
    navigator.serviceWorker.getRegistration("/sw.js").then((registration) => {
      if (registration) {
        // 이미 등록됨 - 업데이트만 확인
        registration.update().catch(() => {
          // 업데이트 실패는 무시 (네트워크 오류 등)
        });
        return;
      }

      // 새로 등록
      navigator.serviceWorker
        .register("/sw.js", { scope: "/", updateViaCache: "none" })
        .then((registration) => {
          console.log("Service Worker registered for caching");

          // 업데이트 감지
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener("statechange", () => {
                if (
                  newWorker.state === "installed" &&
                  navigator.serviceWorker.controller
                ) {
                  // 새 버전 설치됨 - 다음 방문 시 활성화
                  console.log("New Service Worker version available");
                }
              });
            }
          });
        })
        .catch((error) => {
          // SW 등록 실패는 치명적이지 않음 - 캐싱 없이 작동
          console.warn("Service Worker registration failed:", error);
        });
    });
  }, []);

  return null;
}
